import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  TOKEN_USER,
  INFO_USER,
  LAST_PATH
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  data: {},
  lastPath: "",
  token: { "Authorization": "" }
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case TOKEN_USER:
      return {
        ...state,
        token: { "Authorization": `Bearer ${action.payload.token}` },
      };

    case INFO_USER:
      return {
        ...state,
        data: action.payload,
      };

    case LAST_PATH:
      return {
        ...state,
        lastPath: action.payload,
      };

    case LOGOUT_USER:
      return {
        ...state
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state
      };

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default login;
